<template src="./FooterV2.template.html"></template>
<script>
import component from './FooterV2.script.js';

export default component;
</script>
<style src="./FooterV2.style.css" scoped></style>
